<template>
  <div>
    <v-parallax light src="/kim_background.jpg" height="600" min-height="500">

      <v-row align="start" align-content="start" justify="start" style="max-height: 200px;">
        <img src="header_logo.png" alt="logo" class="mx-3 my-3" style="height:45px;" />
      </v-row>

      <v-row v-if="runState < 3" align="center" align-content="start" justify="center">
        <v-col cols="12">
          <h1 class="login-page-claim mx-12">{{$ct('titleNotYet')}}</h1>
        </v-col>
        <v-col cols="12">
          <p class="login-page-claim body-1 mx-12 mt-5">{{$ct('textNotYet')}}</p>
          <p class="login-page-claim body-1 mx-12 mt-5">{{$ct('statusIs')}}: <b>{{translateRunStatus(runState)}}</b></p>
        </v-col>
      </v-row>

      <v-row v-if="runState >= 5" align="center" align-content="start" justify="center">
        <v-col cols="12">
          <h1 class="login-page-claim mx-12">{{$ct('titleTooLate')}}</h1>
        </v-col>
        <v-col cols="12">
          <p class="login-page-claim body-1 mx-12 mt-5">{{$ct('textTooLate')}}</p>
          <p class="login-page-claim body-1 mx-12 mt-5">{{$ct('statusIs')}}: <b>{{translateRunStatus(runState)}}</b></p>
        </v-col>
      </v-row>

    </v-parallax>

    <v-parallax dark src="/kim_splash_login.jpg" height="800">
      <div class="kipat-login-background-blur">

      </div>
      <v-container class="kipat-login-container">
        <v-row align="center" align-content="center" justify="center">

          <v-card max-width="600">
            <v-card-title class="justify-center">{{$ct('options')}}</v-card-title>

            <v-card-text align="center">
              <p>{{$ct('optionsText')}}</p>

              <v-btn color="primary" class="my-5" @click="refresh">
                <v-icon>mdi-refresh</v-icon>
                {{$ct('optionReload')}}
              </v-btn>
              <br/>
              <v-btn color="primary" class="my-5" @click="logout">
                <v-icon>mdi-logout</v-icon>
                {{$ct('optionLogout')}}
              </v-btn>
            </v-card-text>

          </v-card>

        </v-row>
      </v-container>
    </v-parallax>

  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'RunStatusBlocked',
    components: { },
    computed: {
      ...mapState({
        runState: (state) => state.run?.runState || state.run?.runInformation?.runState || 0
      }),
    },
    watch: {
      runState() {
        const self = this;
        if (this.runState > 2 && this.runState < 5) {
          // todo lade alle Daten neu
          self.$router.push({ name: 'overview' })
        } else if (self.$route.name !== 'blocker') {
          self.$router.push({ name: 'blocker' });
        }
      }
    },
    methods: {
      translateRunStatus(status) {
        return this.$i18n.t(`RunStates.state${status}`);
      },
      refresh() {
        this.$api.run.getInfo(['runInformation']);
      },
      logout() {
        this.$store.commit('clearState');
        this.$router.push('/login');
      },
    },
    mounted() {
      if (this.runState > 2 && this.runState < 5) this.$router.push({ name: 'overview' })
    }
  };
</script>

<style scoped>

</style>
